module.exports = __webpack_public_path__ + "static/media/star-low.1f74cb58.png";